const Stopped = ({ width = 20, height = 20, className, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="2 2 16 16"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...rest}
    >
      <path
        cx="10"
        cy="10"
        r="8"
        fill="#A40E26"
        d="M18 10A8 8 0 0 1 10 18 8 8 0 0 1 2 10a8 8 0 0 1 16 0"
      />
      <path
        d="M13 12a1 1 0 0 1 -1 1H8a1 1 0 0 1 -1 -1V8a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1z"
        fill="white"
      />
    </svg>
  );
};

export default Stopped;
